import { onUnmounted } from "vue"
import mitt, { Emitter, Handler } from "mitt"

type Events = Record<string, any> // 你可以改成自己的事件类型
const emitter: Emitter<Events> = mitt<Events>()

function autoOn<Key extends keyof Events>(
  event: Key,
  handler: Handler<Events[Key]>
) {
  emitter.on(event, handler)
  onUnmounted(() => {
    emitter.off(event, handler)
  })
}

const EventBus = {
  ...emitter,
  autoOn
}

export default EventBus